import React, { Component } from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import { formValueSelector } from 'redux-form';
import * as actions from '../../Actions/xpa';
import axios from 'axios';
import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import Paper from '@material-ui/core/Paper';
import fileDownload from 'js-file-download';
import FeedTable from './FeedTable';
import BankFeedForm from './BankFeedForm';
import BankFeedDetails from './BankFeedDetails';
import BankFeedUpload from './UploadBankFeedForm';
import BankFeedDownload from './DownloadBankFeedForm';
import FeedWizardForm from './FeedWizardForm';
import FastlinkWizard from './FastlinkWizard';
import FastlinkEdit from './FastlinkEdit';
import ShareAccessModal from './ShareAccessModal';
import LinkFeedForm from './LinkFeedForm';
import ConfirmationForm from './ConfirmationForm';
import ConnectFeeds from './ConnectFeeds';
import FeedSetup from './FeedSetup';
import SissFeed from './SissFeed';
import { withStyles } from '@material-ui/core/styles';
import DisplayXpaMessage from '../../components/Common/DisplayXpaMessage';
import { ROOT_URL, R1_URL, BNZ_URL } from '../../Actions/types';
import AuthRedirect from './AuthRedirect';
import moment from 'moment';

import css from './bfm.css';

const LightTooltip = withStyles(theme => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

class BankFeedManagment extends Component {
  state = { showModal: false, showDeleted: false, modalType: '', feed: {} };

  componentDidMount() {
    localStorage.removeItem('authtype');
    if (this.props.location.search.length > 10) {
      const queryData = JSON.parse(
        '{"' +
          decodeURI(this.props.location.search)
            .replace('?', '')
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      );


      if (queryData.reload) {
        this.setState({ showModal: false });
      } else if (queryData.regtoken) {
        this.props.history.push(`/bnz/${queryData.regtoken}/${queryData.userid}/${queryData.bookid}`);
      } else {
        Object.keys(queryData).forEach((item) =>
          localStorage.setItem(item.toLowerCase(), queryData[item])
        );
      }
    }
    this.props.getBankFeeds(localStorage.getItem('bookid'));
    // this.props.getR1BankAccounts();
    const isRAH = localStorage.getItem('authtype') === 'RAH';
    const isR1 = !(isRAH || localStorage.getItem('cognitotoken'));
    if (isRAH) {
      this.props.getRAHBankAccounts();
    } else if (isR1) {
      this.props.getR1BankAccounts();
    }
  }

  showError = (message) => this.props.showError(message);

  reloadFeed = () => {
    this.props.getBankFeeds(localStorage.getItem('bookid'));
  };

  showDownload = (feed) => this.setState({ showModal: true, modalType: 'Download Feed Form', feed });

  addBankFeed = (values) => {
    const bankFeed = {
      bankId: this.props.selectedBank.bankId,
      BSB: values.bsb || '000000',
      accountNumber: `${values.account}${values.suffix || ''}`,
      accountName: values.accountName,
      accountType: 1,
    };

    if (bankFeed.bankId === 48) bankFeed.accountNumber = `${bankFeed.accountNumber.substr(0, 6)}XXXXXX${bankFeed.accountNumber.substr(12)}`;

    if (bankFeed.bankId === 40) {
      // BNZ Feed API
      const state = encodeURIComponent(
        `${this.props.xpa.userid}&${localStorage.getItem('bookid')}${localStorage.getItem('isr1') === 'true' ? '&r1' : ''}`
      );
      const url = `${BNZ_URL}${state}`;

      if (localStorage.getItem('cognitotoken')) {
        this.setState({ redirectURL: url, modalType: 'Authorise Feed', bankName: 'BNZ' });
      } else {
        window.open(url, '_blank');
        this.closeModal();
      }
    } else if (bankFeed.bankId === 46) {
      // Fonterra Feed API
      const history = values.history ? values.history.value : 0;
      axios
        .post(
          `${ROOT_URL}/fonterra/approvalurl`,
          { bookId: localStorage.getItem('bookid'), history, isr1: localStorage.getItem('isr1') === 'true' },
          {
            headers: {
              authorizationtoken: localStorage.getItem('token'),
              cognitotoken: localStorage.getItem('cognitotoken'),
              authtype: localStorage.getItem('authtype'),
            },
          }
        )
        .then((response) => {
          if (localStorage.getItem('cognitotoken')) {
            this.setState({ redirectURL: response.data, modalType: 'Authorise Feed', bankName: 'Fonterra' });
          } else {
            window.open(response.data, '_blank');
            this.closeModal();
          }
        });
    } else if (bankFeed.bankId === 42) {
      const history = values.history ? values.history.value : 0;

      // PayPal Feed API
      axios
        .post(
          `${ROOT_URL}/bankfeed/transactions/paypal/approvalurl`,
          { bookId: localStorage.getItem('bookid'), isR1: localStorage.getItem('isr1'), history },
          {
            headers: {
              authorizationtoken: localStorage.getItem('token'),
              cognitotoken: localStorage.getItem('cognitotoken'),
              authtype: localStorage.getItem('authtype'),
            },
          }
        )
        .then((response) => {
          if (localStorage.getItem('cognitotoken')) {
            this.setState({ redirectURL: response.data, modalType: 'Authorise Feed', bankName: 'PayPal' });
          } else {
            window.open(response.data, '_blank');
            this.closeModal();
          }
        });
    } else {
      this.props.addBankFeed(bankFeed, this.showDownload);
      this.closeModal();
    }
  };

  showModal = (feed, modalType) => {
    this.setState({ showModal: true, feed, modalType });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  changeModal = (modalType) => {
    this.dialogContent.scrollTop = 0; // Scroll to Top
    this.setState({ modalType });
  };

  closeYodlee = () => {
    this.props.getBankFeeds(localStorage.getItem('bookid'));
    this.setState({ showModal: false });
  };

  deleteFeed = (feed, yodleeAccountId) => {
    this.props.deleteBankFeed(feed, yodleeAccountId, this.props.xpa.feeds);
    this.closeModal();
  };

  downloadForm = (feedId) => {
    axios
      .get(`${ROOT_URL}/bankfeed/form/${feedId}`, {
        responseType: 'blob',
        headers: {
          authorizationtoken: localStorage.getItem('token'),
          cognitotoken: localStorage.getItem('cognitotoken'),
          authtype: localStorage.getItem('authtype'),
        },
      })
      .then((response) => {
        const type = response.headers['content-type'];
        let fileName = 'Bank_Form.pdf';
        if (type.includes('jpeg')) fileName = 'Bank_Form.jpg';
        if (type.includes('png')) fileName = 'Bank_Form.png';
        fileDownload(response.data, fileName);
      });
  };

  downloadAutoFilledForm = (feed, file) => {
    const today = moment();
    const requestPayload = {
      file: file,
      Account_Name: feed.accountName,
      Account_Number: feed.accountNumber,
      BSB: feed.bsb || feed.BSB,
      Current_Date: today.format('DD/MM/YYYY'),
    };
    axios
      .post(`${ROOT_URL}/bankfeed/registration/form/`, requestPayload, {
        responseType: 'blob',
        headers: {
          authorizationtoken: localStorage.getItem('token'),
          cognitotoken: localStorage.getItem('cognitotoken'),
          Accept: 'application/pdf',
        },
      })
      .then((response) => {
        const fileName = 'Bank_Form.pdf';
        fileDownload(response.data, fileName);
      });
  };

  onNext = (values, isRAH) => {
    if (values.selectedBank === null) this.props.showError('Please select bank, and try again!');
    else {
      if (values.selectedBank.source === 'direct') {
        if (values.selectedBank.bankId === 31) {
          this.setState({ showModal: true, modalType: 'Download Feed Form', feed: { bankId: values.selectedBank.bankId } });
        } else this.changeModal('Add Feed');
      } else if (values.selectedBank.source === 'yodlee') {
        if (isRAH) this.changeModal('Add Yodlee Feed');
        else this.changeModal('Complete Feed Setup');
      } else if (values.selectedBank.source === 'openbanking') {
        this.changeModal('Add Open Banking Feed');
    }
    }
  };

  onShare = () => {
    this.changeModal('Shared Access');
  };

  onLink = (feed) => {
    this.props.linkBankFeed(feed);
    this.closeModal();
  };

  onReLink = (feeds) => {
    this.props.linkExistingFeed(feeds);
    this.closeModal();
  };

  onUnlink = (feed) => {
    this.props.unlinkBankFeed(feed);
    this.closeModal();
  };

  onEdit = ({ accountName }) => {
    const updatedFeed = { ...this.state.feed };
    updatedFeed.accountName = accountName;
    this.props.changeBankFeedName(updatedFeed);
  };

  PaperComponent = (props) => (
    <Draggable handle={'[id*="dialog"]'} cancel={'[class*="MuiDialog-scrollPaper"]'}>
      <Paper {...props} />
    </Draggable>
  );

  render() {
    const { showModal, showDeleted, modalType, feed } = this.state;
    const { xpa, form } = this.props;
    const isXPA = localStorage.getItem('cognitotoken');
    const isRAH = localStorage.getItem('authtype') === 'RAH';
    const hasOpenBanking = !xpa.feeds || xpa.feeds.length === 0 || xpa.feeds.some(x => x.sissAccountId);
    const isR1 = !(isXPA || isRAH);
    const supportEmail = isXPA ? 'support@reckon.com' : 'bankdata@reckon.com';
    const feeds = showDeleted ? xpa.feeds : xpa.feeds && xpa.feeds.filter((item) => !item.isDeleted);
    const deleteMsg =
      isRAH || isR1 ? (
        <div className={css.m10}>
          <p>Are you sure you want to delete this feed or would you like to unlink it so it is available to be linked elsewhere?</p>
          <p>Any uncoded transactions will no longer be available to code. Unlinked feeds can be linked to another bank<br /> account making all the feed’s transactions accessible again.</p>
        </div>
      ) : (
        <div>
          Confirm that you want to remove feed: <span className={css.icons}>{feed.accountName}</span>
        </div>
      );

    return (
      <div className={css.container}>
        <div className={css.card}>
          <div className={[css.dFlex, css.contentBetween, css.pb20].join(' ')}>
            <div className={css.cardHeading}>Bank feed management</div>
            <div className={[css.dFlex, css.contentBetween].join(' ')}>
              <Button
                variant='contained' 
                className={css.mr10} 
                color='primary' 
                size='small' 
                onClick={() => {
                  if (isRAH) {
                    this.showModal({}, 'Find Bank');
                  } else {
                    window.location.href = `${R1_URL}v2/bank-feeds/create#resetWizard=true&bookId=${localStorage.getItem("bookid")}`;
                  }
                }}
              >
                Add Feed
              </Button>
              {!(isRAH || isR1) && (
                <Button variant='contained' color='primary' size='small' onClick={() => this.showModal({}, 'Find Bank')}>
                  <AddIcon size='small' />
                  Share
                </Button>
              )}
            </div>
          </div>
          <div className={css.feedInfo}>
            <p>Bank feeds let you automatically import transactions with select banks directly into Reckon.<br />
               You can set up bank feeds via Open Banking, Yodlee or through a direct connection with select banks.</p>
            <p><a href="https://help.reckon.com/article/sl3ygs4fre-creating-and-managing-bank-feeds" target="_blank">Learn more about bank feed management</a> or for assistance, please contact the <a href="https://www.reckon.com/au/support/ticket" target="_blank">Reckon Support Team</a>.</p>
          </div>

          <FeedTable
            bankAccounts={xpa.bankAccounts}
            feeds={feeds}
            isRAH={isRAH}
            isR1={isR1}
            onIconClicked={this.showModal}
            unlink={this.onUnlink} />

          <div className={css.footer}>
            {isR1 && <div className={[css.dFlex, css.contentBetween].join(' ')}>
              <div>
                <LightTooltip enterDelay={700}  title="Add existing bank feeds to this book that are not currently assigned to any book or file that you have access to.">
                  <Button onClick={() => this.showModal({}, 'Link Existing Feed')} color='primary'>
                    Connect Existing Feeds
                  </Button>
                </LightTooltip>
              </div>
              <div>
                <Button onClick={() => this.setState({ showDeleted: !showDeleted })} color='primary'>
                  {showDeleted ? 'Hide Deleted Feeds' : 'Display Deleted Feeds'}
                </Button>
              </div>
            </div>}

            {isXPA && (
              <p className={css.terms}>
                <i>
                  By registering a bank feed you are agreeing to our terms and conditions and will be charged a fee. For further information
                  click{' '}
                  <a rel='noopener noreferrer' target='_blank' href='https://www.aps-software.com/terms/bankdata/'>
                    here
                  </a>
                </i>
              </p>

            )}
          </div>
        </div>

        <Dialog
          className={css.dialogFont}
          open={showModal}
          onClose={this.closeModal}
          maxWidth={false}
          fullWidth={false}
          PaperComponent={this.PaperComponent}
        >
          <div id='dialog' className={[css.dFlex, css.contentBetween, css.alignCenter, css.p15, css.borderBottom].join(' ')}>
            <div>{modalType}</div>
            <div className='fas fa-times' style={{ color: '#999' }} onClick={this.closeModal} />
          </div>

          <DialogContent ref={(node) => (this.dialogContent = node)}>
            {modalType === 'Authorise Feed' && <AuthRedirect redirectURL={this.state.redirectURL} bank={this.state.bankName} />}
            {modalType === 'Add Feed' && (
              <BankFeedForm
                onSubmit={this.addBankFeed}
                onYodlee={() => this.changeModal('Add Yodlee Feed')}
                userid={xpa.userid}
                onBack={() => this.changeModal('Find Bank')}
              />
            )}
            {modalType === 'Shared Access' && <ShareAccessModal onClose={this.closeModal} />}
            {modalType === 'Find Bank' && (!(isRAH || isR1) ? <DisplayXpaMessage closeModal={this.closeModal} />:
              <FeedWizardForm
                onConnect={() => this.changeModal('Link Existing Feed')}
                onSubmit={() => this.onNext(form.feedWizardForm.values, isRAH)}
                onClose={this.closeModal}
                isRAH={isRAH}
                isR1={isR1}
                hasOpenBanking={hasOpenBanking}
              />
            )}
            {modalType === 'Complete Feed Setup' && (
              <FeedSetup
                onShare={() => this.changeModal('Shared Access')}
                onAuthorise={() => this.changeModal('Add Yodlee Feed')}
                onClose={this.closeModal}
              />
            )}
            {modalType === 'Add Open Banking Feed' && <SissFeed onCompleted={this.closeYodlee} onClose={this.closeModal} />}
            {modalType === 'Add Yodlee Feed' && <FastlinkWizard closeYodlee={this.closeYodlee} />}
            {modalType === 'Reauthenticate Feed' && <FastlinkEdit feed={feed} closeYodlee={this.closeYodlee} />}
            {modalType === 'Feed Details' && (
              <BankFeedDetails
                initialValues={{ accountName: feed.accountName }}
                onSubmit={this.onEdit}
                feed={feed}
                onFeedUpdate={(feed) => this.setState({ feed })}
                downloadForm={this.downloadForm}
                onEditYodlee={() => this.changeModal('Reauthenticate Feed')}
              />
            )}
            {modalType === 'Upload Feed Form' && (
              <BankFeedUpload
                feed={feed}
                onClose={this.closeModal}
                downloadForm={this.downloadForm}
                reloadFeed={this.reloadFeed}
                showError={this.showError}
              />
            )}
            {modalType === 'Download Feed Form' && (
              <BankFeedDownload
                feed={feed}
                userid={xpa.userid}
                downloadForm={this.downloadForm}
                downloadAutoFilledForm={this.downloadAutoFilledForm}
              />
            )}
            {modalType === 'Feed Mapping' && (
              <LinkFeedForm
                feed={feed}
                bankAccounts={xpa.bankAccounts}
                isRAH={isRAH}
                isR1={isR1}
                onClose={this.closeModal}
                onLink={this.onLink}
                onSave={() => this.changeModal('Confirmation')}
                clientAccountIds={feeds.map(feed => feed.clientAccountId)}
              />
            )}
            {modalType === 'Confirmation' && (
              <ConfirmationForm
                feed={feed}
                isRAH={isRAH}
                isR1={isR1}
                isR1BankAccount={isR1 && feed.R1BankAccountId && xpa.bankAccounts.some(x => x.R1BankAccountID === feed.R1BankAccountId)}
                onBack={() => this.changeModal('Feed Mapping')}
                onLink={this.onLink}
              />
            )}
            {modalType === 'Link Existing Feed' && (
              <ConnectFeeds onReLink={this.onReLink} onClose={this.closeModal} onBack={() => this.changeModal('Find Bank')} />
            )}
            {modalType === 'Delete Feed' &&
              (feed.bankId === 1 && feed.status === 'Active' ? (
                <div className={css.w400}>
                  Login to your ANZ Internet Banking, then select <b>Profile</b>, and <b>Manage Bank Feeds</b> to remove this feed
                </div>
              ) : (
                deleteMsg
              ))}
          </DialogContent>

          {modalType === 'Delete Feed' && (
            <DialogActions>
              <div className={css.buttonContainer}>
                <div>
                  <Button onClick={this.closeModal} color='primary'>
                    Close
                  </Button>
                </div>
                <div>
                  {(isRAH || isR1) && (
                    <Button onClick={() => this.onUnlink(feed)} color='primary'>
                      Unlink
                    </Button>
                  )}
                  {(feed.bankId !== 1 || feed.status !== 'Active') && (
                    <Button onClick={() => this.deleteFeed(feed.feedId, feed.YodleeItemAccountID)} style={{ color: 'red' }}>
                      Delete Feed
                    </Button>
                  )}
                </div>
              </div>
            </DialogActions>
          )}
        </Dialog>
      </div>
    );
  }
}

const selector = formValueSelector('feedWizardForm');

function mapStateToProps(state) {
  const { xpa, form } = state;
  const selectedBank = selector(state, 'selectedBank');
  return { xpa, form, selectedBank };
}

export default connect(
  mapStateToProps,
  actions
)(BankFeedManagment);



// WEBPACK FOOTER //
// ./src/components/FeedManagment/BankFeedManagment.js